import { useState, useEffect } from 'react';
import './scss/layout.scss';

import Subject from './assets/hero-subject.png';
import DataIntoDecisions from './assets/data2decisions.png';
import Tankers from './assets/tankers.jpg';
import { ArrowRightOutlined } from '@ant-design/icons';

import { Header } from './components/Header';
import { Collapsible } from './components/Collapsible';
import { Partners } from './components/Partners';
import { DTPModal } from './components/DTPModal';
import { Footer } from './components/Footer';
import { ImgSlider } from './components/ImgSlider';

import showcase1 from './assets/dtp/dtp-showcase-1.png'
import showcase2 from './assets/dtp/dtp-showcase-2.png'
import showcase3 from './assets/dtp/dtp-showcase-3.png'

import tab1_1 from './assets/tabs/tab1-1.png';
import tab1_2 from './assets/tabs/tab1-2.png';
import tab1_3 from './assets/tabs/tab1-3.png';
import tab2_1 from './assets/tabs/tab2-1.png';
import tab2_2 from './assets/tabs/tab2-2.png';
import tab2_3 from './assets/tabs/tab2-3.png';
import tab3_1 from './assets/tabs/tab3-1.png';
import tab3_2 from './assets/tabs/tab3-2.png';
import tab4_1 from './assets/tabs/tab4-1.png';
import tab4_2 from './assets/tabs/tab4-2.png';
import tab4_3 from './assets/tabs/tab4-3.png';

function App() {
  const [selectedTab, setSelectedTab] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(0);
  const [activeKey, setActiveKey] = useState('1');
  const [dashImg, setDashImg] = useState(tab1_1);

  const onClickCollapse = (e) => {
    setActiveKey(e[0]);
    switch(selectedTab){
      case 0:
        if (e[0] ==='3'){
          setDashImg(tab1_3);
        } else if  (e[0] ==='2'){
          setDashImg(tab1_2);
        }else{
          setDashImg(tab1_1);
        }
        break;
      case 1:
        if (e[0] ==='3'){
          setDashImg(tab2_3);
        } else if  (e[0] ==='2'){
          setDashImg(tab2_2);
        }else{
          setDashImg(tab2_1);
        }
        break;
      case 2:
        if (e[0] ==='2'){
          setDashImg(tab3_2);
        }else{
          setDashImg(tab3_1);
        }
        break;
      case 3:
        if (e[0] ==='3'){
          setDashImg(tab4_3);
        } else if  (e[0] ==='2'){
          setDashImg(tab4_2);
        }else{
          setDashImg(tab4_1);
        }
        break;
      default:
        if (e[0] ==='3'){
          setDashImg(tab1_3);
        } else if  (e[0] ==='2'){
          setDashImg(tab1_2);
        }else{
          setDashImg(tab1_1);
        }
        break;
    }
  }

  useEffect(()=>{
    setActiveKey(['1']);
    switch(selectedTab){
      case 0:
        setDashImg(tab1_1);
        break;
      case 1:
        setDashImg(tab2_1);
        break;
      case 2:
        setDashImg(tab3_1);
        break;
      case 3:
        setDashImg(tab4_1);
        break;
      default:
        setDashImg(tab1_1);
        break;
    }
  },[selectedTab])

  return (
    <>
    <Header/>
    <div className="App">
      <div className='section-1' id="home">
        <img src={Subject} className='subject' alt='Subject'/>
        <div className='content'>
          <h1 className='title'>Holistic Solutions for Smarter Terminals</h1>
          <p className='description'>Partnering for your success, we transform businesses with human-centered strategies and forward thinking to create custom, scalable, and sustainable solutions that enhance growth and efficiency.</p>
          <div className='buttons'>
            <button className='primary-btn'
             onClick={(e)=>document.querySelector('#contact-us').scrollIntoView({
              behavior: 'smooth',
              block: 'center',
          })}>Let's Work Together</button>
            <button className='secondary-btn'
             onClick={()=>window.open('https://www.qad.works', '_blank').focus()} style={{cursor:'pointer'}}>Explore our Solutions <ArrowRightOutlined/></button>
            <button className='secondary-btn-sm'
             onClick={()=>window.open('https://www.qad.works', '_blank').focus()} style={{cursor:'pointer'}}>Explore our Solutions</button>
          </div>
        </div>
      </div>
      <div className='section-2' id='data-into-decisions'>
          <div className='section-bg'/>
          <div className='content'>
            <img src={DataIntoDecisions} className='header-image' alt='Data Into Decisions'/>
            <p className='description-w'>Empower your business with action-driven insights for smarter strategies and faster growth. Our reliable consultants partner with you on key decisions to help you to achieve and even exceed your goals through tailor-fitted solutions.</p>
            <div className='tabs'>
              <button className={selectedTab===0?'active-tab':'tab'} onClick={()=>setSelectedTab(0)}>Elevate Efficiency</button>
              <button className={selectedTab===1?'active-tab':'tab'} onClick={()=>setSelectedTab(1)}>Increase Profit</button>
              <button className={selectedTab===2?'active-tab':'tab'} onClick={()=>setSelectedTab(2)}>Informed Decisions</button>
              <button className={selectedTab===3?'active-tab':'tab'} onClick={()=>setSelectedTab(3)}>Scalability</button>
            </div>
          </div>
          <div className='dashboard-wrapper'>
            <img className="dashboard" src={dashImg} alt='Dashboard'/>
          </div>
          <div className='bottom-content'>
            <Collapsible tab={selectedTab} onChange={onClickCollapse} activeKey={activeKey}/>
            <img className="dashboard-w" src={dashImg} alt='Dashboard'/>
          </div>
      </div>
      <div className='section-3' id="digital-transformation">
        <div className='content'>
            <p className='showcase'>Project Highlight</p>
            <h1 className='title'>Our Work Speaks for Itself</h1>
            <div className='cards'>
              <div className='group'>
                <div className='card-border' style={{borderLeft:"8px solid #F4C00D"}}>
                  <div className='card'>
                    <p className='count'>15<span className='superscript'>%</span></p>
                    <p className='label'>Reduction in client's operational costs</p>
                  </div>
                </div>
                <div className='card-border' style={{borderLeft:"8px solid #26262B"}}>
                  <div className='card'>
                    <p className='count'>2.5<span className='superscript'>x</span></p>
                    <p className='label'>Digital investment ROI within<br/>3-5 years</p>
                  </div>
                </div>
              </div>
              <div className='group'>
                <div className='card-border' style={{borderLeft:"8px solid #2146D4"}}>
                  <div className='card'>
                    <p className='count'>80<span className='superscript'>% faster</span></p>
                    <p className='label'>Data warehousing report generation time</p>
                  </div>
                </div>
                <div className='card-border' style={{borderLeft:"8px solid #E8721F"}}>
                  <div className='card'>
                    <p className='count'>15<span className='superscript'>%</span></p>
                    <p className='label'>Improved cycle time across modalities <span style={{fontWeight:300}}>impacting an average of 50 daily transactions</span></p>
                  </div>
                </div>
              </div>
            </div>
            <div className='dtp' id="projects">
              <div className='about'>
                <h3 className='title'>Digital Transformation Project</h3>
                <p className='description'>
                  QADworks paved the way for a global entity in the storage terminal industry, specializing in the storage and distribution of chemicals and petroleum products, to digitize its Marine, Truck, and Rail operations to enable real-time data capture and updates. This effort streamlined planning and scheduling tools, enhancing workflow integration, reducing errors, and saving time. Overall, these changes fostered reliable internal integration and empowered the company to make data-driven decisions that improved everyday operations and addressed critical paths.
                </p>
                <button className='secondary-btn' onClick={()=>setIsModalOpen(true)}>View Project <ArrowRightOutlined/></button>
              </div>
              <div className='showcase-imgs'>
                <img src={showcase1} alt='Showcase 1' />
                <img src={showcase2} alt='Showcase 2' />
                <img src={showcase3} alt='Showcase 3' />
              </div>
            </div>
            <ImgSlider/>
        </div>
      </div>
      
      <div className='section-4' id="partners">
        <div className='content'>
            <p className='showcase'>Our Partners</p>
            <h1 className='title'>Turning Projects into Lasting Partnerships</h1>
            <Partners/>
        </div>
      </div>

      <div className='section-5' id="contact-us">
        <img src={Tankers} alt='Tankers'/>
        <div className='content'>
          <div className='container'>
            <h1 className='title'>Make the Change.</h1>
            <p className='description'>Let's talk. Have a meal with us and let's discover solutions for your company.</p>
            <button className='tertiary-btn' onClick={()=>window.open('https://calendly.com/qadworks', '_blank').focus()}>Schedule a Call <ArrowRightOutlined/></button>
          </div>
        </div>
      </div>
      <Footer/>
      <DTPModal open={isModalOpen} onCancel={()=>setIsModalOpen(false)}/>
    </div>
    </>
  );
}

export default App;
